var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    transform: "translate(-32.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidenav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(32.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2C5DE6",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5367171,15.224673 L12.6271984,13.2030827 L12.6271984,17.8839679 L10.5367171,20.0189192 L10.5367171,15.224673 L10.5367171,15.224673 L10.5367171,15.224673 L10.5367171,15.224673 L10.5367171,15.224673 Z M17.3148719,8.66982667 L17.3148719,13.0965754 L13.5773681,16.9135856 L13.5773681,12.2841422 L17.3148719,8.66982667 L17.3148719,8.66982667 L17.3148719,8.66982667 L17.3148719,8.66982667 L17.3148719,8.66982667 Z M18.2651188,12.8667023 L23.0294662,12.8667023 L23.0294662,8.01455472 L18.2651188,8.01455472 L18.2651188,12.8667023 L18.2651188,12.8667023 L18.2651188,12.8667023 L18.2651188,12.8667023 L18.2651188,12.8667023 Z M18.8456495,17.6540949 L14.151265,17.6540949 L17.8887689,13.8370847 L22.3975624,13.8370847 L18.8456495,17.6540949 L18.8456495,17.6540949 L18.8456495,17.6540949 L18.8456495,17.6540949 L18.8456495,17.6540949 Z M15.9510182,20.7647853 L11.1053687,20.7647853 L13.2010954,18.6245559 L17.9426103,18.6245559 L15.9510182,20.7647853 L15.9510182,20.7647853 L15.9510182,20.7647853 L15.9510182,20.7647853 L15.9510182,20.7647853 Z M23.5602437,24.758021 L7.29126813,24.6601005 L10.155199,21.7352464 L16.3588399,21.7352464 L23.9796359,13.5456864 L23.9796359,7.04409368 L17.614008,7.04409368 L9.58647022,14.8071518 L9.58647022,20.9893802 L6,24.652144 L6.00015427,24.6523015 L6.00007714,24.6523015 L6.00007714,25.590385 L24,25.6987042 L24,25.2098105 C23.8285251,25.0335851 23.7317957,24.9342464 23.5602437,24.758021 L23.5602437,24.758021 L23.5602437,24.758021 L23.5602437,24.758021 L23.5602437,24.758021 L23.5602437,24.758021 Z",
    id: "quill",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.f0f95175e5dea19e6bad15f21069e110.svg";
export { ForwardRef as ReactComponent };